import { derive } from 'store-utils';
import { createAsyncState } from 'async-utils';
import { Direction, Nullable } from 'common-types';
import { createStore } from 'store-utils';
import {
  ArtifactInfo,
  ArtifactsSortKey,
  ArtifactTopFiilter,
  ArtifactTopFiltersTypes,
  FilterArtifactsType,
} from '../types/artifacts-type';
import { SupplyChainItem } from '../../supply-chain/supplychain-types';

export const initialArtifactsStore: Partial<ArtifactsStoreState> = {
  artifacts: [],
  loading: createAsyncState(),
  loadingFilters: createAsyncState(),
  loadingTopFilters: createAsyncState(),
  offset: 0,
  total: 0,
  totalFiltered: 0,
  selectedArtifact: null,
  selectedArtifactId: '',
  loadingArtifact: false,
  artifactModal: false,
  order: Direction.DESC,
  orderBy: ArtifactsSortKey.ArtifactType,
  filtersArtifacts: {},
  filtersOpen: true,
  totalFilterd: 0,
  artifactsFiltersList: null,
  artifactsTopFiltersList: [],
  filterArtifactsBy: {},
  topFiltersArtifactsBy: [],
  supplyChainItems: [],
  artifactsFiltersTypeSearch: null,
  searchValues: {},
};

const baseStore = createStore<ArtifactsStoreState>(
  {
    ...JSON.parse(JSON.stringify(initialArtifactsStore)),
    loading: createAsyncState(),
    loadingFilters: createAsyncState(),
  },
  'Artifacts Store',
);

const ArtifactsStore = derive(
  {
    numberOfFilters: get => {
      const { filterArtifactsBy } = get(baseStore);
      return (
        Object.keys(filterArtifactsBy).reduce(
          (acc, key) => acc + filterArtifactsBy[key].length,
          0,
        ) || 0
      );
    },
  },
  { proxy: baseStore },
);

export interface ArtifactsStoreState {
  artifacts: ArtifactInfo[];
  loading: ReturnType<typeof createAsyncState>;
  loadingFilters: ReturnType<typeof createAsyncState>;
  loadingTopFilters: ReturnType<typeof createAsyncState>;
  offset: number;
  total: number;
  totalFiltered: number;
  selectedArtifact: Nullable<ArtifactInfo>;
  selectedArtifactId: string;
  loadingArtifact: boolean;
  artifactModal: boolean;
  order: Direction;
  orderBy: ArtifactsSortKey;
  filtersArtifacts: FilterArtifactsType;
  filtersOpen: boolean;
  totalFilterd: number;
  artifactsFiltersList: Nullable<FilterArtifactsType>;
  artifactsTopFiltersList: ArtifactTopFiilter[];
  filterArtifactsBy: {};
  topFiltersArtifactsBy: ArtifactTopFiltersTypes[];
  supplyChainItems: SupplyChainItem[];
  searchValues: {};
  artifactsFiltersTypeSearch: Nullable<FilterArtifactsType>;
}

export default ArtifactsStore;
